import React from "react";
import { Typography, Grid } from "@material-ui/core";

function ProductLine({
  price,
  quantity,
  summary,
  type,
  attachmentUrl,
  section,
}) {
  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      justify="space-between"
      style={{ marginBottom: 30 }}
    >
      <Typography
        className="order-summary"
        style={{
          width: "55%",
          fontSize: 16,
          fontWeight: section ? "bold" : 500,
        }}
      >
        {section ? section : summary}
      </Typography>
      <Grid className="product-card-info">
        <Typography>
          {attachmentUrl && (
            <a href={attachmentUrl} target="_blank" rel="noopener noreferrer">
              Чертеж
            </a>
          )}
        </Typography>
        <Typography
          style={{
            fontSize: 16,
            margin: 0,
            lineHeight: 1.5,
            textAlign: "center",
          }}
        >
          {quantity} {type}
        </Typography>
        <Typography
          style={{
            fontSize: 16,
            margin: 0,
            lineHeight: 1.5,
            textAlign: "center",
          }}
        >
          {section ? "" : `${Math.round(Number(price))} руб`}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default function ProductList({ lines }) {
  return (
    <Grid container direction="column" wrap="nowrap">
      {lines.map((line, index) => (
        <ProductLine key={index} {...line} />
      ))}

      <Typography
        style={{
          textAlign: "center",
          lineHeight: 1.5,
          fontSize: 10,
          fontWeight: 200,
          margin: 0,
        }}
      >
        Факт оплаты подразумевает согласие со списком товаров, способом и
        стоимостью отгрузки. Обращаем Ваше внимание, что изделия изготавливаемые
        Подрядчиком относятся к категории №4 Перечня непродовольственных товаров
        надлежащего качества, не подлежащих возврату или обмену, утвержденном
        Постановлением Правительства РФ от 19.01.1998 № 55. В соответствии с п.
        4. ст. 26.1. Закона РФ № 2300-I «О Защите прав потребителей» Заказчик
        вправе отказаться от заказанного Товара только до момента запуска Заказа
        в работу (статус “Заказ в производстве“).
      </Typography>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/Order/ProductList.jsx